import { EntityModel, User } from '@cksoftware/react-base';
import { AddressModel } from '../addressModel';

export type DlmsUser = User & {
  UserProfiles: UserProfile[];
  CurrentProfileId: number;
};

export type ProfileUser = {
  UserProfile: UserProfile;
  User: DlmsUser;
};

export type UserProfile = EntityModel & {
  Address: AddressModel;
  AdminComments: string | undefined;
  BuyerName: string | undefined;
  CompanyName: string;
  CreditApprovalNotes: string | undefined;
  FirstName: string;
  LastName: string;
  MobilePhone: string | undefined;
  WorkPhone: string | undefined;
  UserId: string;
};

export function getCurrentProfile(user: DlmsUser | undefined) {
  if (!user) {
    return undefined;
  }
  return user.UserProfiles.find((val) => val.Id == user.CurrentProfileId);
}

export type CreateUser = {
  ReceiveEmailUpdates: boolean;
  AgreeToTerms: boolean;
  EmailVerificationToken: string;
  Password: string;
  ConfirmPassword: string;
};

export type CreateDlmsUser = Partial<User> & Partial<UserProfile> & Partial<CreateUser> & {};
